import { motion } from "framer-motion";

const BANNER = "https://www.laser-machines.com/images/banner1.webp";

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative flex min-h-[78vh] items-center justify-center overflow-hidden pt-[100px]">
      <img src={BANNER} alt="Penta Laser fiber laser cutting machine in operation" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-black/45" />
      <div className="relative mx-auto max-w-4xl px-4 py-24 text-center sm:px-8">
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          data-testid="hero-heading"
          className="text-4xl font-bold uppercase leading-tight tracking-wide text-white sm:text-5xl lg:text-6xl"
        >
          Industrial Laser System Manufacturer
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.25 }}
          data-testid="hero-subheading"
          className="mx-auto mt-6 max-w-2xl text-base text-white/85 sm:text-lg"
        >
          High-power laser cutting, tube cutting, laser welding and automated production lines - supplied and supported in Australia from Hallam, Victoria.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-10 flex flex-wrap justify-center gap-4"
        >
          <a href="#machines" data-testid="hero-machines-btn" className="bg-laser px-8 py-3.5 text-sm font-semibold uppercase tracking-wide text-white transition-colors duration-150 hover:bg-laser-hover">
            Explore Machines
          </a>
          <a href="#contact" data-testid="hero-contact-btn" className="border border-white/70 px-8 py-3.5 text-sm font-semibold uppercase tracking-wide text-white transition-colors duration-150 hover:border-laser hover:text-laser">
            Contact Us
          </a>
        </motion.div>
      </div>
    </section>
  );
}
